import { Avatar, AvatarFallback } from "@vega-core/components/shadcn/avatar";

type Props = {
  name?: string;
};

export const OrganisationAvatarName = ({ name }: Props) => (
  <>
    <Avatar className="h-6 w-6">
      <AvatarFallback>{name}</AvatarFallback>
    </Avatar>
    <span className="overflow-hidden text-ellipsis whitespace-nowrap body-base-medium inline-block">
      {name}
    </span>
  </>
);
